import React from 'react';
import {Map, GoogleApiWrapper, HeatMap, InfoWindow} from 'google-maps-react';
import {Avatar} from '@material-ui/core';
import '../Deals/locationMap.css';

const infoWindowStyles = (businessName) => {
    return {
        textOverflow: businessName.length > 10 ? 'ellipsis !important' : 'clip !important',
        width: businessName.length > 10 ? '150px' : '100px'
    }
}

const MapComponent = (props) => {
    return <React.Fragment>
        <Map
            google={props.google}
            zoom={14}
            initialCenter={{lat: Number(props.businessInfo.BusinessUser.Address_Lat), lng: Number(props.businessInfo.BusinessUser.Address_Long)}}
            fullscreenControl={false}
            disableDoubleClickZoom={true}
            defaultEnableRetinaIcons={false}
            scrollwheel={false}
            streetViewControl={false}
            disableDefaultUI={true}
            draggable={false}
        >
            <InfoWindow
                
                position={{lat: Number(props.businessInfo.BusinessUser.Address_Lat), lng: Number(props.businessInfo.BusinessUser.Address_Long)}}
                visible={true}
            >
                <div className="info">
                    <div style={{margin: '0px 10px 5px 0px'}}>
                        {
                            props.businessPhoto ?
                                <Avatar className='infoAvatar'>
                                    <img
                                        src={`https://d2gnb7jphto2jj.cloudfront.net/UploadImages/AppUserProfileImages/ProfileOriginalImage/${props.businessPhoto}`}
                                        alt="infoImage" className="heatmap-infowindow-avatar-img"
                                    />
                                </Avatar>
                                        :
                                <img
                                    src={require(`./../../../images/Alphabets/${props.businessName.match(/[a-z]/i)[0].toUpperCase()}.png`)}
                                    className="heatmap-infowindow-avatar-img"/>
                        }
                    </div>
                    <div className="infoDetail" style={{textAlign: 'left'}}>
                    <div style={infoWindowStyles(props.businessName)}>{props.businessName}</div>
                        <span>{props.UsersCheckedIn ? `${props.UsersCheckedIn + 1} People Chatting Now`:`${1} Person Chatting Now`}</span>
                    </div>
                </div>
            </InfoWindow>
            {props.businessInfo.BusinessUser.Address_Lat && props.businessInfo.BusinessUser.Address_Long &&
            <HeatMap
                positions={[
                    {lat: Number(props.businessInfo.BusinessUser.Address_Lat), lng: Number(props.businessInfo.BusinessUser.Address_Long)},
                ]}
                options={{radius: 20}}
                opacity={0.7}
            />
            }
        </Map>
    </React.Fragment>
};
export default GoogleApiWrapper({
    apiKey: 'AIzaSyDOEDrHL3W3HUA6hk2u59bITUj-a2HgO4U',
    v: '3.30',
    libraries: ['visualization']
})(MapComponent);
